import { Colors, Img, Lightning, Registry, Router, Utils, Storage } from "@lightningjs/sdk";
import { SPLASH_TIME, PLATFORMS, STORAGE_KEYS } from "../lib/utils";
import theme from "../lib/theme";
import { Lifecycle, Parameters } from "@firebolt-js/sdk";
import { fetchAndCacheAppInfo } from "../api/queries";

interface BootTemplateSpec extends Lightning.Component.TemplateSpec {
    Splash: object;
}

interface BootTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}
//

export class Boot
    extends Lightning.Component<BootTemplateSpec, BootTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<BootTemplateSpec>
{
    _animation: any;

    static override _template(): Lightning.Component.Template<BootTemplateSpec> {
        return {
            w: theme.layout.w,
            h: theme.layout.h,
            rect: true,
            color: Colors(theme.colors.bg.primary).get(),
            Splash: {
                w: theme.layout.w,
                h: theme.layout.h,
                alpha: 0.01,
                texture: Img(Utils.asset("images/splashscreen.jpg")).cover(theme.layout.w, theme.layout.h)
            }
        };
    }

    override _init() {
	// Lifecycle.ready();

        // Fetch CMS-managed app info (contact email, T&C) and persist it.
        // Fire-and-forget; settings pages also retry when opened.
        void fetchAndCacheAppInfo();

        this.tag("Splash")!.on("txLoaded", () => {
            this._resume();
        });

        this.tag("Splash")!.on("txError", () => {});

        // Samsung Tizen specific fallback for splash rendering
        try {
            const platform = Storage.get(STORAGE_KEYS.platform);
            if (platform === PLATFORMS.samsung) {
                this.patch({
                    Splash: {
                        w: theme.layout.w,
                        h: theme.layout.h,
                        // Older Tizen WebKit has issues with Img().cover textures occasionally
                        // Use direct src-based image rendering as a fallback
                        texture: undefined,
                        src: Utils.asset("images/splashscreen.jpg")
                    }
                });
            }
        } catch (e) {
            console.error(e);
        }

        window.addEventListener("dragover", (e) => e.preventDefault());
        window.addEventListener("drop", (e) => {
            e.preventDefault();

            const file = e.dataTransfer?.files?.[0];
            if (file && file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onload = () => {
                    // Dispatch a custom event to Lightning
                    const dropEvent = new CustomEvent("logo-drop", { detail: reader.result });
                    window.dispatchEvent(dropEvent);
                };
                reader.readAsDataURL(file);
            }
        });
    }

    _resume() {
        this.tag("Splash")!.patch({
            smooth: {
                alpha: 1
            }
        });
    }
}
